(() => {
  const calendar = document.querySelector('[data-release-calendar]');
  if (!calendar) return;
  const list = calendar.querySelector('[data-release-list]');
  const empty = calendar.querySelector('[data-release-empty]');
  const formatDate = (value, options) => new Intl.DateTimeFormat('en-US', options).format(new Date(`${value}T12:00:00`));
  const add = (parent, tag, className, text) => { const node = document.createElement(tag); node.className = className; if (text) node.textContent = text; parent.appendChild(node); return node; };

  fetch(calendar.dataset.releaseSource)
    .then((response) => response.ok ? response.json() : [])
    .then((releases) => {
      const today = new Date(); today.setHours(0, 0, 0, 0);
      const upcoming = releases.filter((release) => new Date(`${release.release_date}T12:00:00`) > today);
      if (!upcoming.length) { empty.hidden = false; return; }
      const grouped = upcoming.reduce((groups, release) => { const key = release.release_date.slice(0, 7); (groups[key] ||= []).push(release); return groups; }, {});
      Object.keys(grouped).sort().forEach((month) => {
        const group = add(list, 'section', 'release-calendar__group');
        add(group, 'h2', 'release-calendar__group-title', formatDate(`${month}-01`, { month: 'long', year: 'numeric' }));
        const grid = add(group, 'div', 'release-calendar__grid');
        grouped[month].sort((a, b) => a.release_date.localeCompare(b.release_date)).forEach((release) => {
          const card = add(grid, release.handle ? 'a' : 'article', 'release-calendar__card');
          if (release.handle) card.href = `/products/${release.handle}`;
          const imageWrap = add(card, 'div', 'release-calendar__image-wrap');
          if (release.image) {
            const image = add(imageWrap, 'img', 'release-calendar__image'); image.src = release.image; image.alt = release.name; image.loading = 'lazy';
          } else {
            add(imageWrap, 'div', 'release-calendar__placeholder', release.placeholder_brand || 'SOLE PLAY');
          }
          add(imageWrap, 'span', 'release-calendar__date', formatDate(release.release_date, { month: 'short', day: 'numeric' }));
          const details = add(card, 'div', 'release-calendar__details'); add(details, 'h3', 'release-calendar__name', release.name);
          const meta = add(details, 'p', 'release-calendar__meta'); add(meta, 'span', '', release.sku); add(meta, 'span', '', release.retail_price ? `$${Number(release.retail_price).toFixed(2)}` : 'Retail TBA');
        });
      });
    })
    .catch(() => { empty.hidden = false; });
})();
